export const customDeviceList = [
  {
    make: 'Apple',
    models: [
      {
        name: 'iPad 10.2"',
        aspectRatio: 0.75,
        diagonalMm: 259.08,
        id: 'apple-ipad-10.2"',
      },
      {
        name: 'iPad Air',
        aspectRatio: 0.75,
        diagonalMm: 266.7,
        id: 'apple-ipad-air',
      },
      {
        name: 'iPad Air (2020)',
        aspectRatio: 0.6949152542372882,
        diagonalMm: 276.86,
        id: 'apple-ipad-air-(2020)',
      },
      {
        name: 'iPad Mini',
        aspectRatio: 0.75,
        diagonalMm: 200.66,
        id: 'apple-ipad-mini',
      },
      {
        name: 'iPad Pro 11"',
        aspectRatio: 0.6984924623115578,
        diagonalMm: 279.4,
        id: 'apple-ipad-pro-11"',
      },
      {
        name: 'iPad Pro 12.9"',
        aspectRatio: 0.7496339677891655,
        diagonalMm: 327.65999999999997,
        id: 'apple-ipad-pro-12.9"',
      },
      {
        name: 'iPhone 11',
        aspectRatio: 0.46205357142857145,
        diagonalMm: 154.93999999999997,
        id: 'apple-iphone-11',
      },
      {
        name: 'iPhone 11 Pro',
        aspectRatio: 0.4618226600985222,
        diagonalMm: 147.32,
        id: 'apple-iphone-11-pro',
      },
      {
        name: 'iPhone 11 Pro Max',
        aspectRatio: 0.46205357142857145,
        diagonalMm: 165.1,
        id: 'apple-iphone-11-pro-max',
      },
      {
        name: 'iPhone 12',
        aspectRatio: 0.46208530805687204,
        diagonalMm: 154.93999999999997,
        id: 'apple-iphone-12',
      },
      {
        name: 'iPhone 12 Mini',
        aspectRatio: 0.46153846153846156,
        diagonalMm: 137.16,
        id: 'apple-iphone-12-mini',
      },
      {
        name: 'iPhone 12 Pro',
        aspectRatio: 0.46208530805687204,
        diagonalMm: 154.93999999999997,
        id: 'apple-iphone-12-pro',
      },
      {
        name: 'iPhone 12 Pro Max',
        aspectRatio: 0.46220302375809935,
        diagonalMm: 170.18,
        id: 'apple-iphone-12-pro-max',
      },
      {
        name: 'iPhone 13',
        aspectRatio: 0.462,
        diagonalMm: 152.07,
        id: 'apple-iphone-13',
      },
      {
        name: 'iPhone 13 Mini',
        aspectRatio: 0.462,
        diagonalMm: 138.0762,
        id: 'apple-iphone-13-mini',
      },
      {
        name: 'iPhone 13 Pro',
        aspectRatio: 0.462,
        diagonalMm: 152.0768,
        id: 'apple-iphone-13-pro',
      },
      {
        name: 'iPhone 13 Pro Max',
        aspectRatio: 0.462,
        diagonalMm: 162.5634,
        id: 'apple-iphone-13-pro-max',
      },
      {
        name: 'iPhone 14',
        aspectRatio: 0.462,
        diagonalMm: 152.0768,
        id: 'apple-iphone-14',
      },
      {
        name: 'iPhone 14 Plus',
        aspectRatio: 0.462,
        diagonalMm: 162.5634,
        id: 'apple-iphone-14-plus',
      },
      {
        name: 'iPhone 14 Pro',
        aspectRatio: 0.461,
        diagonalMm: 154.3366063,
        id: 'apple-iphone-14-pro',
      },
      {
        name: 'iPhone 14 Pro Max',
        aspectRatio: 0.461,
        diagonalMm: 163.5591,
        id: 'apple-iphone-14-pro-max',
      },
      {
        name: 'iPhone 5',
        aspectRatio: 0.5633802816901409,
        diagonalMm: 101.6,
        id: 'apple-iphone-5',
      },
      {
        name: 'iPhone 5c',
        aspectRatio: 0.5633802816901409,
        diagonalMm: 101.6,
        id: 'apple-iphone-5c',
      },
      {
        name: 'iPhone 5s',
        aspectRatio: 0.5633802816901409,
        diagonalMm: 101.6,
        id: 'apple-iphone-5s',
      },
      {
        name: 'iPhone 6',
        aspectRatio: 0.5622188905547226,
        diagonalMm: 119.38,
        id: 'apple-iphone-6',
      },
      {
        name: 'iPhone 6s',
        aspectRatio: 0.5622188905547226,
        diagonalMm: 119.38,
        id: 'apple-iphone-6s',
      },
      {
        name: 'iPhone 6s Plus',
        aspectRatio: 0.5625,
        diagonalMm: 139.7,
        id: 'apple-iphone-6s-plus',
      },
      {
        name: 'iPhone 7',
        aspectRatio: 0.5622188905547226,
        diagonalMm: 119.38,
        id: 'apple-iphone-7',
      },
      {
        name: 'iPhone 7 Plus',
        aspectRatio: 0.5625,
        diagonalMm: 139.7,
        id: 'apple-iphone-7-plus',
      },
      {
        name: 'iPhone 8',
        aspectRatio: 0.5622188905547226,
        diagonalMm: 119.38,
        id: 'apple-iphone-8',
      },
      {
        name: 'iPhone 8 Plus',
        aspectRatio: 0.5625,
        diagonalMm: 139.7,
        id: 'apple-iphone-8-plus',
      },
      {
        name: 'iPhone SE',
        aspectRatio: 0.5633802816901409,
        diagonalMm: 101.6,
        id: 'apple-iphone-se',
      },
      {
        name: 'iPhone SE (2020)',
        aspectRatio: 0.5622188905547226,
        diagonalMm: 119.38,
        id: 'apple-iphone-se-(2020)',
      },
      {
        name: 'iPhone X',
        aspectRatio: 0.4618226600985222,
        diagonalMm: 147.32,
        id: 'apple-iphone-x',
      },
      {
        name: 'iPhone XR',
        aspectRatio: 0.46205357142857145,
        diagonalMm: 154.93999999999997,
        id: 'apple-iphone-xr',
      },
      {
        name: 'iPhone XS Max',
        aspectRatio: 0.46205357142857145,
        diagonalMm: 165.1,
        id: 'apple-iphone-xs-max',
      },
    ],
  },
  {
    make: 'Samsung',
    models: [
      {
        name: 'A30',
        aspectRatio: 0.4618834080717489,
        diagonalMm: 162.56,
        id: 'samsung-a30',
      },
      {
        name: 'A31',
        aspectRatio: 0.45027322404371584,
        diagonalMm: 162.56,
        id: 'samsung-a31',
      },
      {
        name: 'A32',
        aspectRatio: 0.45027322404371584,
        diagonalMm: 162.56,
        id: 'samsung-a32',
      },
      {
        name: 'A50',
        aspectRatio: 0.4618834080717489,
        diagonalMm: 162.56,
        id: 'samsung-a50',
      },
      {
        name: 'A50s',
        aspectRatio: 0.4618834080717489,
        diagonalMm: 162.56,
        id: 'samsung-a50s',
      },
      {
        name: 'A51',
        aspectRatio: 0.45027322404371584,
        diagonalMm: 165.1,
        id: 'samsung-a51',
      },
      {
        name: 'A6s',
        aspectRatio: 0.5,
        diagonalMm: 152.39999999999998,
        id: 'samsung-a6s',
      },
      {
        name: 'A70s',
        aspectRatio: 0.45076586433260396,
        diagonalMm: 170.18,
        id: 'samsung-a70s',
      },
      {
        name: 'A71',
        aspectRatio: 0.45076586433260396,
        diagonalMm: 170.18,
        id: 'samsung-a71',
      },
      {
        name: 'Fold',
        aspectRatio: 0.7137546468401487,
        diagonalMm: 185.42,
        id: 'samsung-fold',
      },
      {
        name: 'J7 Prime2',
        aspectRatio: 0.5628415300546448,
        diagonalMm: 139.7,
        id: 'samsung-j7-prime2',
      },
      {
        name: 'Note 3',
        aspectRatio: 0.5625,
        diagonalMm: 144.78,
        id: 'samsung-note-3',
      },
      {
        name: 'Note 4',
        aspectRatio: 0.5625,
        diagonalMm: 144.78,
        id: 'samsung-note-4',
      },
      {
        name: 'Note 8',
        aspectRatio: 0.4864864864864865,
        diagonalMm: 160.01999999999998,
        id: 'samsung-note-8',
      },
      {
        name: 'Note 9',
        aspectRatio: 0.4864864864864865,
        diagonalMm: 162.56,
        id: 'samsung-note-9',
      },
      {
        name: 'Note10',
        aspectRatio: 0.47410817031070196,
        diagonalMm: 160.01999999999998,
        id: 'samsung-note10',
      },
      {
        name: 'Note10+',
        aspectRatio: 0.47410817031070196,
        diagonalMm: 172.72,
        id: 'samsung-note10+',
      },
      {
        name: 'Note20',
        aspectRatio: 0.45027322404371584,
        diagonalMm: 170.18,
        id: 'samsung-note20',
      },
      {
        name: 'Note20 Ultra',
        aspectRatio: 0.4665911664779162,
        diagonalMm: 175.26,
        id: 'samsung-note20-ultra',
      },
      {
        name: 'S10',
        aspectRatio: 0.47368421052631576,
        diagonalMm: 154.93999999999997,
        id: 'samsung-s10',
      },
      {
        name: 'S10 Lite',
        aspectRatio: 0.45076586433260396,
        diagonalMm: 170.18,
        id: 'samsung-s10-lite',
      },
      {
        name: 'S10+',
        aspectRatio: 0.47410817031070196,
        diagonalMm: 162.56,
        id: 'samsung-s10+',
      },
      {
        name: 'S20',
        aspectRatio: 0.45,
        diagonalMm: 157.48,
        id: 'samsung-s20',
      },
      {
        name: 'S20 FE',
        aspectRatio: 0.45076586433260396,
        diagonalMm: 165.1,
        id: 'samsung-s20-fe',
      },
      {
        name: 'S20 Ultra',
        aspectRatio: 0.45027322404371584,
        diagonalMm: 175.26,
        id: 'samsung-s20-ultra',
      },
      {
        name: 'S20+',
        aspectRatio: 0.4496487119437939,
        diagonalMm: 170.18,
        id: 'samsung-s20+',
      },
      {
        name: 'S21 Ultra 5G',
        aspectRatio: 0.4496487119437939,
        diagonalMm: 172.72,
        id: 'samsung-s21-ultra-5g',
      },
      {
        name: 'S6',
        aspectRatio: 0.5625,
        diagonalMm: 129.54,
        id: 'samsung-s6',
      },
      {
        name: 'S6 edge',
        aspectRatio: 0.5625,
        diagonalMm: 129.54,
        id: 'samsung-s6-edge',
      },
      {
        name: 'S7',
        aspectRatio: 0.5625,
        diagonalMm: 129.54,
        id: 'samsung-s7',
      },
      {
        name: 'S7 Edge',
        aspectRatio: 0.5625,
        diagonalMm: 139.7,
        id: 'samsung-s7-edge',
      },
      {
        name: 'S8',
        aspectRatio: 0.4864864864864865,
        diagonalMm: 147.32,
        id: 'samsung-s8',
      },
      {
        name: 'S8+',
        aspectRatio: 0.4864864864864865,
        diagonalMm: 157.48,
        id: 'samsung-s8+',
      },
      {
        name: 'S9',
        aspectRatio: 0.4864864864864865,
        diagonalMm: 147.32,
        id: 'samsung-s9',
      },
      {
        name: 'S9+',
        aspectRatio: 0.4864864864864865,
        diagonalMm: 157.48,
        id: 'samsung-s9+',
      },
      {
        name: 'Z Flip',
        aspectRatio: 0.4103585657370518,
        diagonalMm: 170.18,
        id: 'samsung-z-flip',
      },
      {
        name: 'Z Fold2',
        aspectRatio: 0.8007246376811594,
        diagonalMm: 193.04,
        id: 'samsung-z-fold2',
      },
      {
        name: 'Z Fold3',
        aspectRatio: 0.8007246376811594,
        diagonalMm: 187.96,
        id: 'samsung-z-fold3',
      },
    ],
  },
  {
    make: 'Huawei',
    models: [
      {
        name: 'Mate 10 Lite',
        aspectRatio: 0.5,
        diagonalMm: 149.86,
        id: 'huawei-mate-10-lite',
      },
      {
        name: 'Mate 20 Lite',
        aspectRatio: 0.46153846153846156,
        diagonalMm: 160.01999999999998,
        id: 'huawei-mate-20-lite',
      },
      {
        name: 'Mate 20 Pro',
        aspectRatio: 0.46153846153846156,
        diagonalMm: 162.30599999999998,
        id: 'huawei-mate-20-pro',
      },
      {
        name: 'Mate 30',
        aspectRatio: 0.46153846153846156,
        diagonalMm: 168.148,
        id: 'huawei-mate-30',
      },
      {
        name: 'Mate 30 Pro',
        aspectRatio: 0.49,
        diagonalMm: 165.862,
        id: 'huawei-mate-30-pro',
      },
      {
        name: 'MatePad Pro',
        aspectRatio: 1.6,
        diagonalMm: 274.32,
        id: 'huawei-matepad-pro',
      },
      {
        name: 'Nova 6',
        aspectRatio: 0.45,
        diagonalMm: 166.878,
        id: 'huawei-nova-6',
      },
      {
        name: 'Nova 7 Pro',
        aspectRatio: 0.46153846153846156,
        diagonalMm: 166.878,
        id: 'huawei-nova-7-pro',
      },
      {
        name: 'Nova 7 SE',
        aspectRatio: 0.45,
        diagonalMm: 165.1,
        id: 'huawei-nova-7-se',
      },
      {
        name: 'Nova 7i',
        aspectRatio: 0.4675324675324675,
        diagonalMm: 162.56,
        id: 'huawei-nova-7i',
      },
      {
        name: 'P10 Plus',
        aspectRatio: 0.5625,
        diagonalMm: 139.7,
        id: 'huawei-p10-plus',
      },
      {
        name: 'P20 lite',
        aspectRatio: 0.47368421052631576,
        diagonalMm: 148.33599999999998,
        id: 'huawei-p20-lite',
      },
      {
        name: 'P20 Pro',
        aspectRatio: 0.4819277108433735,
        diagonalMm: 154.93999999999997,
        id: 'huawei-p20-pro',
      },
      {
        name: 'P30',
        aspectRatio: 0.46153846153846156,
        diagonalMm: 154.93999999999997,
        id: 'huawei-p30',
      },
      {
        name: 'P30 Lite',
        aspectRatio: 0.4669260700389105,
        diagonalMm: 156.21,
        id: 'huawei-p30-lite',
      },
      {
        name: 'P30 Pro',
        aspectRatio: 0.46153846153846156,
        diagonalMm: 164.338,
        id: 'huawei-p30-pro',
      },
      {
        name: 'P40',
        aspectRatio: 0.46153846153846156,
        diagonalMm: 154.93999999999997,
        id: 'huawei-p40',
      },
      {
        name: 'P40 Lite',
        aspectRatio: 0.4675324675324675,
        diagonalMm: 162.56,
        id: 'huawei-p40-lite',
      },
      {
        name: 'P40 Pro',
        aspectRatio: 0.45454545454545453,
        diagonalMm: 167.132,
        id: 'huawei-p40-pro',
      },
      {
        name: 'P8 Lite (2017)',
        aspectRatio: 0.5625,
        diagonalMm: 132.07999999999998,
        id: 'huawei-p8-lite-(2017)',
      },
      {
        name: 'P9, P9 Lite',
        aspectRatio: 0.5625,
        diagonalMm: 132.07999999999998,
        id: 'huawei-p9,-p9-lite',
      },
      {
        name: 'Y9 Prime',
        aspectRatio: 0.46153846153846156,
        diagonalMm: 167.386,
        id: 'huawei-y9-prime',
      },
      {
        name: 'Y9s',
        aspectRatio: 0.46153846153846156,
        diagonalMm: 167.386,
        id: 'huawei-y9s',
      },
    ],
  },
  {
    make: 'Blackberry',
    models: [
      {
        name: 'Classic',
        aspectRatio: 1,
        diagonalMm: 88.89999999999999,
        id: 'blackberry-classic',
      },
      {
        name: 'Keyone',
        aspectRatio: 0.6666666666666666,
        diagonalMm: 114.3,
        id: 'blackberry-keyone',
      },
      {
        name: 'Leap',
        aspectRatio: 0.5611510791366906,
        diagonalMm: 127,
        id: 'blackberry-leap',
      },
      {
        name: 'Passport',
        aspectRatio: 1,
        diagonalMm: 114.3,
        id: 'blackberry-passport',
      },
      {
        name: 'Priv',
        aspectRatio: 0.5625,
        diagonalMm: 137.16,
        id: 'blackberry-priv',
      },
      {
        name: 'Q10',
        aspectRatio: 1,
        diagonalMm: 78.74,
        id: 'blackberry-q10',
      },
      {
        name: 'Z10',
        aspectRatio: 0.6,
        diagonalMm: 106.67999999999999,
        id: 'blackberry-z10',
      },
      {
        name: 'Z30',
        aspectRatio: 0.5625,
        diagonalMm: 127,
        id: 'blackberry-z30',
      },
    ],
  },
  {
    make: 'Google',
    models: [
      {
        name: 'Pixel',
        aspectRatio: 0.5628415300546448,
        diagonalMm: 127,
        id: 'google-pixel',
      },
      {
        name: 'Pixel 2',
        aspectRatio: 0.5628415300546448,
        diagonalMm: 127,
        id: 'google-pixel-2',
      },
      {
        name: 'Pixel 2 XL',
        aspectRatio: 0.5006075334143378,
        diagonalMm: 152.39999999999998,
        id: 'google-pixel-2-xl',
      },
      {
        name: 'Pixel 3',
        aspectRatio: 0.5,
        diagonalMm: 139.7,
        id: 'google-pixel-3',
      },
      {
        name: 'Pixel 3 XL',
        aspectRatio: 0.48699763593380613,
        diagonalMm: 160.01999999999998,
        id: 'google-pixel-3-xl',
      },
      {
        name: 'Pixel 3a',
        aspectRatio: 0.4863861386138614,
        diagonalMm: 142.23999999999998,
        id: 'google-pixel-3a',
      },
      {
        name: 'Pixel 3a XL',
        aspectRatio: 0.5006075334143378,
        diagonalMm: 152.39999999999998,
        id: 'google-pixel-3a-xl',
      },
      {
        name: 'Pixel 4',
        aspectRatio: 0.4734939759036145,
        diagonalMm: 144.78,
        id: 'google-pixel-4',
      },
      {
        name: 'Pixel 4 XL',
        aspectRatio: 0.47410817031070196,
        diagonalMm: 160.01999999999998,
        id: 'google-pixel-4-xl',
      },
      {
        name: 'Pixel 4a',
        aspectRatio: 0.4618096357226792,
        diagonalMm: 147.57399999999998,
        id: 'google-pixel-4a',
      },
      {
        name: 'Pixel 5',
        aspectRatio: 0.4618096357226792,
        diagonalMm: 152.39999999999998,
        id: 'google-pixel-5',
      },
      {
        name: 'Pixel 6',
        aspectRatio: 0.45,
        diagonalMm: 162.5584,
        id: 'google-pixel-6',
      },
      {
        name: 'Pixel 6 Pro',
        aspectRatio: 0.461,
        diagonalMm: 165.2286,
        id: 'google-pixel-6-pro',
      },
      {
        name: 'Pixel 7',
        aspectRatio: 0.45,
        diagonalMm: 159.26904,
        id: 'google-pixel-7',
      },
      {
        name: 'Pixel XL',
        aspectRatio: 0.5628415300546448,
        diagonalMm: 139.7,
        id: 'google-pixel-xl',
      },
    ],
  },
  {
    make: 'HTC',
    models: [
      {
        name: 'Desire 19s',
        aspectRatio: 0.47368421052631576,
        diagonalMm: 157.48,
        id: 'htc-desire-19s',
      },
      {
        name: 'One',
        aspectRatio: 0.5625,
        diagonalMm: 119.38,
        id: 'htc-one',
      },
      {
        name: 'One M8',
        aspectRatio: 0.5625,
        diagonalMm: 127,
        id: 'htc-one-m8',
      },
      {
        name: 'One M9',
        aspectRatio: 0.5625,
        diagonalMm: 127,
        id: 'htc-one-m9',
      },
      {
        name: 'U Ultra',
        aspectRatio: 0.5625,
        diagonalMm: 144.78,
        id: 'htc-u-ultra',
      },
      {
        name: 'U11',
        aspectRatio: 0.5625,
        diagonalMm: 139.7,
        id: 'htc-u11',
      },
      {
        name: 'U11+',
        aspectRatio: 0.5,
        diagonalMm: 152.39999999999998,
        id: 'htc-u11+',
      },
      {
        name: 'U12+',
        aspectRatio: 0.5,
        diagonalMm: 152.39999999999998,
        id: 'htc-u12+',
      },
      {
        name: 'Wildfire X',
        aspectRatio: 0.47368421052631576,
        diagonalMm: 157.48,
        id: 'htc-wildfire-x',
      },
    ],
  },
  {
    make: 'Honor',
    models: [
      {
        name: '6X',
        aspectRatio: 0.5625,
        diagonalMm: 139.7,
        id: 'honor-6x',
      },
      {
        name: '7X',
        aspectRatio: 0.5,
        diagonalMm: 150.62199999999999,
        id: 'honor-7x',
      },
      {
        name: '8X',
        aspectRatio: 0.46153846153846156,
        diagonalMm: 165.1,
        id: 'honor-8x',
      },
      {
        name: '9X',
        aspectRatio: 0.46153846153846156,
        diagonalMm: 167.386,
        id: 'honor-9x',
      },
    ],
  },

  {
    make: 'LG',
    models: [
      {
        name: 'G Pad 5 10.1"',
        aspectRatio: 0.625,
        diagonalMm: 256.53999999999996,
        id: 'lg-g-pad-5-10.1"',
      },
      {
        name: 'G4, G3',
        aspectRatio: 0.5625,
        diagonalMm: 139.7,
        id: 'lg-g4,-g3',
      },
      {
        name: 'G5',
        aspectRatio: 0.5625,
        diagonalMm: 134.61999999999998,
        id: 'lg-g5',
      },
      {
        name: 'G6',
        aspectRatio: 0.5,
        diagonalMm: 144.78,
        id: 'lg-g6',
      },
      {
        name: 'G7 Fit, G7 One',
        aspectRatio: 0.46153846153846156,
        diagonalMm: 154.93999999999997,
        id: 'lg-g7-fit,-g7-one',
      },
      {
        name: 'G8 ThinQ',
        aspectRatio: 0.46153846153846156,
        diagonalMm: 154.93999999999997,
        id: 'lg-g8-thinq',
      },
      {
        name: 'G8X ThinQ',
        aspectRatio: 0.46153846153846156,
        diagonalMm: 162.56,
        id: 'lg-g8x-thinq',
      },
      {
        name: 'K10, K11 Plus',
        aspectRatio: 0.5625,
        diagonalMm: 134.61999999999998,
        id: 'lg-k10,-k11-plus',
      },
      {
        name: 'K20 (2019)',
        aspectRatio: 0.5,
        diagonalMm: 138.43,
        id: 'lg-k20-(2019)',
      },
      {
        name: 'K30',
        aspectRatio: 0.5625,
        diagonalMm: 134.61999999999998,
        id: 'lg-k30',
      },
      {
        name: 'K40',
        aspectRatio: 0.5,
        diagonalMm: 144.78,
        id: 'lg-k40',
      },
      {
        name: 'K50',
        aspectRatio: 0.47368421052631576,
        diagonalMm: 159.004,
        id: 'lg-k50',
      },
      {
        name: 'K51S',
        aspectRatio: 0.45,
        diagonalMm: 166.36999999999998,
        id: 'lg-k51s',
      },
      {
        name: 'K61',
        aspectRatio: 0.46153846153846156,
        diagonalMm: 165.862,
        id: 'lg-k61',
      },
      {
        name: 'Nexus 5',
        aspectRatio: 0.5625,
        diagonalMm: 125.73,
        id: 'lg-nexus-5',
      },
      {
        name: 'Stylo 4',
        aspectRatio: 0.5,
        diagonalMm: 157.48,
        id: 'lg-stylo-4',
      },
      {
        name: 'Stylo 5',
        aspectRatio: 0.5,
        diagonalMm: 157.48,
        id: 'lg-stylo-5',
      },
      {
        name: 'Tribute Empire',
        aspectRatio: 0.5625,
        diagonalMm: 127,
        id: 'lg-tribute-empire',
      },
      {
        name: 'W30',
        aspectRatio: 0.47368421052631576,
        diagonalMm: 159.004,
        id: 'lg-w30',
      },
    ],
  },
  {
    make: 'Microsoft',
    models: [
      {
        name: 'Lumia 1020',
        aspectRatio: 0.6666666666666666,
        diagonalMm: 114.3,
        id: 'microsoft-lumia-1020',
      },
      {
        name: 'Lumia 1520',
        aspectRatio: 0.5625,
        diagonalMm: 152.39999999999998,
        id: 'microsoft-lumia-1520',
      },
      {
        name: 'Lumia 520',
        aspectRatio: 0.6666666666666666,
        diagonalMm: 101.6,
        id: 'microsoft-lumia-520',
      },
      {
        name: 'Lumia 650',
        aspectRatio: 0.5625,
        diagonalMm: 127,
        id: 'microsoft-lumia-650',
      },
      {
        name: 'Lumia 925',
        aspectRatio: 0.6666666666666666,
        diagonalMm: 114.3,
        id: 'microsoft-lumia-925',
      },
      {
        name: 'Lumia 950 XL',
        aspectRatio: 0.5622435020519836,
        diagonalMm: 144.78,
        id: 'microsoft-lumia-950-xl',
      },
    ],
  },
  {
    make: 'Motorola',
    models: [
      {
        name: 'Moto G8',
        aspectRatio: 0.46153846153846156,
        diagonalMm: 162.56,
        id: 'motorola-moto-g8',
      },
      {
        name: 'Nexus 6',
        aspectRatio: 0.5622435020519836,
        diagonalMm: 151.384,
        id: 'motorola-nexus-6',
      },
      {
        name: 'Nexus 6P',
        aspectRatio: 0.5622435020519836,
        diagonalMm: 144.78,
        id: 'motorola-nexus-6p',
      },
    ],
  },
  {
    make: 'OnePlus',
    models: [
      {
        name: '6',
        aspectRatio: 0.47410817031070196,
        diagonalMm: 101.6,
        id: 'oneplus-6',
      },
      {
        name: '6T',
        aspectRatio: 0.4618834080717489,
        diagonalMm: 162.814,
        id: 'oneplus-6t',
      },
      {
        name: '7',
        aspectRatio: 0.4618834080717489,
        diagonalMm: 162.814,
        id: 'oneplus-7',
      },
      {
        name: '7 Pro',
        aspectRatio: 0.4618834080717489,
        diagonalMm: 169.41799999999998,
        id: 'oneplus-7-pro',
      },
      {
        name: '7T',
        aspectRatio: 0.45076586433260396,
        diagonalMm: 166.36999999999998,
        id: 'oneplus-7t',
      },
      {
        name: '7T Pro',
        aspectRatio: 0.4618834080717489,
        diagonalMm: 169.41799999999998,
        id: 'oneplus-7t-pro',
      },
      {
        name: '8',
        aspectRatio: 0.45027322404371584,
        diagonalMm: 166.36999999999998,
        id: 'oneplus-8',
      },
      {
        name: '8 Pro',
        aspectRatio: 0.45474613686534215,
        diagonalMm: 172.212,
        id: 'oneplus-8-pro',
      },
      {
        name: '8T',
        aspectRatio: 0.45076586433260396,
        diagonalMm: 166.36999999999998,
        id: 'oneplus-8t',
      },
      {
        name: '9',
        aspectRatio: 0.45027322404371584,
        diagonalMm: 166.36999999999998,
        id: 'oneplus-9',
      },
      {
        name: '9 Pro',
        aspectRatio: 0.44831338411316646,
        diagonalMm: 170.18,
        id: 'oneplus-9-pro',
      },
      {
        name: 'Nord',
        aspectRatio: 0.45027322404371584,
        diagonalMm: 163.576,
        id: 'oneplus-nord',
      },
    ],
  },

  {
    make: 'Sony',
    models: [
      {
        name: 'Xperia 1',
        aspectRatio: 0.428125,
        diagonalMm: 165.1,
        id: 'sony-xperia-1',
      },
      {
        name: 'Xperia 10',
        aspectRatio: 0.42857142857142855,
        diagonalMm: 152.39999999999998,
        id: 'sony-xperia-10',
      },
      {
        name: 'Xperia 10 Plus',
        aspectRatio: 0.42857142857142855,
        diagonalMm: 165.1,
        id: 'sony-xperia-10-plus',
      },
      {
        name: 'Xperia 5',
        aspectRatio: 0.42857142857142855,
        diagonalMm: 154.93999999999997,
        id: 'sony-xperia-5',
      },
      {
        name: 'Xperia C4',
        aspectRatio: 0.5625,
        diagonalMm: 139.7,
        id: 'sony-xperia-c4',
      },
      {
        name: 'Xperia L4',
        aspectRatio: 0.42857142857142855,
        diagonalMm: 157.48,
        id: 'sony-xperia-l4',
      },
      {
        name: 'Xperia X',
        aspectRatio: 0.5625,
        diagonalMm: 127,
        id: 'sony-xperia-x',
      },
      {
        name: 'Xperia XZ',
        aspectRatio: 0.5625,
        diagonalMm: 132.07999999999998,
        id: 'sony-xperia-xz',
      },
      {
        name: 'Xperia Z Ultra',
        aspectRatio: 0.5625,
        diagonalMm: 162.56,
        id: 'sony-xperia-z-ultra',
      },
      {
        name: 'Xperia Z2 / Z3',
        aspectRatio: 0.5625,
        diagonalMm: 132.07999999999998,
        id: 'sony-xperia-z2-/-z3',
      },
      {
        name: 'Xperia Z3',
        aspectRatio: 0.5625,
        diagonalMm: 132.07999999999998,
        id: 'sony-xperia-z3',
      },
      {
        name: 'Xperia Z5',
        aspectRatio: 0.5625,
        diagonalMm: 132.07999999999998,
        id: 'sony-xperia-z5',
      },
    ],
  },
  {
    make: 'Xiaomi',
    models: [
      {
        name: 'Mi 10',
        aspectRatio: 0.4618096357226792,
        diagonalMm: 169.41799999999998,
        id: 'xiaomi-mi-10',
      },
      {
        name: 'Mi 10 Pro',
        aspectRatio: 0.4618096357226792,
        diagonalMm: 169.41799999999998,
        id: 'xiaomi-mi-10-pro',
      },
      {
        name: 'Mi 10T, Xiaomi Mi 10T Pro',
        aspectRatio: 0.45017182130584193,
        diagonalMm: 169.41799999999998,
        id: 'xiaomi-mi-10t,-xiaomi-mi-10t-pro',
      },
      {
        name: 'Mi 3',
        aspectRatio: 0.5625,
        diagonalMm: 127,
        id: 'xiaomi-mi-3',
      },
      {
        name: 'Mi 6',
        aspectRatio: 0.48161764705882354,
        diagonalMm: 149.35199999999998,
        id: 'xiaomi-mi-6',
      },
      {
        name: 'Mi 8 SE',
        aspectRatio: 0.48161764705882354,
        diagonalMm: 149.35199999999998,
        id: 'xiaomi-mi-8-se',
      },
      {
        name: 'Mi 8, Mi 8 Pro',
        aspectRatio: 0.4810281517747858,
        diagonalMm: 157.73399999999998,
        id: 'xiaomi-mi-8,-mi-8-pro',
      },
      {
        name: 'Mi 9 Lite',
        aspectRatio: 0.4618096357226792,
        diagonalMm: 162.30599999999998,
        id: 'xiaomi-mi-9-lite',
      },
      {
        name: 'Mi 9 SE',
        aspectRatio: 0.4618096357226792,
        diagonalMm: 151.63799999999998,
        id: 'xiaomi-mi-9-se',
      },
      {
        name: 'Mi 9, Mi 9T',
        aspectRatio: 0.4618096357226792,
        diagonalMm: 162.30599999999998,
        id: 'xiaomi-mi-9,-mi-9t',
      },
      {
        name: 'Redmi Note 7',
        aspectRatio: 0.4618096357226792,
        diagonalMm: 160.01999999999998,
        id: 'xiaomi-redmi-note-7',
      },
      {
        name: 'Redmi Note 8',
        aspectRatio: 0.4618096357226792,
        diagonalMm: 160.01999999999998,
        id: 'xiaomi-redmi-note-8',
      },
      {
        name: 'Redmi Note 8 Pro',
        aspectRatio: 0.4618096357226792,
        diagonalMm: 165.862,
        id: 'xiaomi-redmi-note-8-pro',
      },
      {
        name: 'Redmi Note 9',
        aspectRatio: 0.4618096357226792,
        diagonalMm: 165.862,
        id: 'xiaomi-redmi-note-9',
      },
      {
        name: 'Redmi Note 9 Pro',
        aspectRatio: 0.45017182130584193,
        diagonalMm: 169.41799999999998,
        id: 'xiaomi-redmi-note-9-pro',
      },
    ],
  },
  {
    make: 'vivo',
    models: [
      {
        name: 'Y20',
        aspectRatio: 0.45081967213114754,
        diagonalMm: 165.35399999999998,
        id: 'vivo-y20',
      },
    ],
  },
];
